import {Injectable} from '@angular/core';
import {EditorRegistryService} from '../../../diagram-render/mx-graph/editor/editor-registry.service';
import {UndoService} from '../../../commands/undo.service';
import {ShapeCommand} from '../../../commands/commands.template';

interface PreviewElement {
  previewElement: HTMLElement;
  offset: {dx: number; dy: number};
}

type MxDropEventCallback = (graph, event, target, x: number, y: number) => void;

declare const mxUtils: any;

@Injectable({providedIn: 'root'})
export class DragHandlerService {
  constructor(
    private readonly registryService: EditorRegistryService,
    private readonly undoService: UndoService
  ) {}

  public createDragHandler(
    createCommand: (x: number, y: number, event?) => ShapeCommand | void,
    element: HTMLElement,
    previewElement: PreviewElement,
    isStickerHandler = false
  ) {
    const onDrop = (graph, event, target, x: number, y: number) => {
      event.preventDefault();

      if (graph.isEnabled() || isStickerHandler) {
        const command = createCommand(x, y, event);

        if (command instanceof ShapeCommand) {
          const constructedCell = this.undoService.executeCommand(command);

          if (constructedCell) {
            graph.setSelectionCell(constructedCell);
          }
        }
      }
    };

    this.makeElementDraggable(element, previewElement, onDrop);
  }

  public createPreviewElement(
    width: number,
    height: number,
    offsetX: number = 0,
    offsetY: number = 0
  ) {
    const element = document.createElement('div');

    element.style.width = `${width}px`;
    element.style.height = `${height}px`;
    element.style.border = '1px dashed black';

    return {previewElement: element, offset: {dx: offsetX, dy: offsetY}};
  }

  private makeElementDraggable(
    element: HTMLElement,
    previewElement: PreviewElement,
    onDrop: MxDropEventCallback
  ) {
    const graph = this.registryService.getGraph();
    const {
      previewElement: dragElement,
      offset: {dx, dy}
    } = previewElement;
    const args = Object.values({
      element,
      graph,
      onDropHandler: onDrop,
      dragElement,
      dx,
      dy,
      autoscroll: graph.autoscroll,
      scalePreview: true,
      highlightDropTargets: false
    });
    const dragSource = mxUtils.makeDraggable(...args);

    dragSource.setGuidesEnabled(true);
  }
}
